// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Professional Footer Styles */

.Footer_footer__AcWGP {
  margin-top: 3rem;
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  color: #fff;
  position: relative;
  overflow: hidden;
}

/* Decorative gradient orbs */
.Footer_footer__AcWGP::before {
  content: '';
  position: absolute;
  top: -100px;
  right: -100px;
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(255, 107, 157, 0.12) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.Footer_footer__AcWGP::after {
  content: '';
  position: absolute;
  bottom: -80px;
  left: -80px;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(124, 58, 237, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.Footer_container__fvqaJ {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 1.5rem;
  position: relative;
  z-index: 1;
}

/* Main Footer */
.Footer_mainFooter__doDxW {
  padding: 2.5rem 0 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.Footer_footerGrid__xk7f- {
  display: grid;
  grid-template-columns: 1.4fr 0.9fr 0.9fr 1.2fr 0.8fr;
  gap: 1.75rem;
}

/* Brand Column */
.Footer_brandColumn__L2Qv8 {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.Footer_logo__Gkrq2 {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.Footer_logo__Gkrq2:hover {
  opacity: 0.9;
}

.Footer_logo__Gkrq2 img {
  height: 36px;
  width: auto;
  object-fit: contain;
}

.Footer_tagline__1SXmj {
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.85rem;
  line-height: 1.6;
  max-width: 260px;
  margin: 0;
}

/* Social Links */
.Footer_socialLinks__O8B6S {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.25rem;
}

.Footer_socialIcon__j0f-t {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.Footer_socialIcon__j0f-t svg {
  width: 16px;
  height: 16px;
}

.Footer_socialIcon__j0f-t:hover {
  background: linear-gradient(135deg, #ff6b9d, #7c3aed);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 107, 157, 0.3);
  border-color: transparent;
}

/* Links Columns */
.Footer_linksColumn__jhB6P {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.Footer_linksColumn__jhB6P h4,
.Footer_contactColumn__IyIKK h4 {
  font-family: 'Fredoka', sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  color: #fff;
  margin: 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid rgba(255, 107, 157, 0.3);
  display: inline-block;
}

.Footer_linksColumn__jhB6P ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.Footer_linksColumn__jhB6P li a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 0.85rem;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.Footer_linksColumn__jhB6P li a::before {
  content: '';
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #ff6b9d, #7c3aed);
  transition: width 0.3s ease;
}

.Footer_linksColumn__jhB6P li a:hover {
  color: #fff;
  transform: translateX(4px);
}

.Footer_linksColumn__jhB6P li a:hover::before {
  width: 12px;
}

/* Contact Column */
.Footer_contactColumn__IyIKK {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.Footer_locationCard__2nNih {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 0.875rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.Footer_locationHeader__HV2X0 {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.Footer_locationIcon__9BLBK {
  width: 16px;
  height: 16px;
  color: #ff6b9d;
}

.Footer_locationName__RSbjp {
  font-family: 'Fredoka', sans-serif;
  font-weight: 600;
  font-size: 0.9rem;
  color: #fff;
}

.Footer_address__khcda {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8rem;
  line-height: 1.45;
  margin: 0;
}

.Footer_hoursRow__uwPvH {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.8rem;
}

.Footer_clockIcon__hX2tC {
  width: 14px;
  height: 14px;
  color: #7c3aed;
}

.Footer_phoneButton__Grg0s {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.75rem;
  background: linear-gradient(135deg, #ff6b9d, #7c3aed);
  color: #fff;
  text-decoration: none;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.3s ease;
  width: fit-content;
}

.Footer_phoneButton__Grg0s svg {
  width: 14px;
  height: 14px;
}

.Footer_phoneButton__Grg0s:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(255, 107, 157, 0.4);
}

.Footer_directionsLink__jnxzK {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: #06b6d4;
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.Footer_directionsLink__jnxzK svg {
  width: 14px;
  height: 14px;
}

.Footer_directionsLink__jnxzK:hover {
  color: #fff;
  transform: translateX(3px);
}

/* Hours Column */
.Footer_hoursColumn__28Xri {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.Footer_hoursColumn__28Xri h4 {
  font-family: 'Fredoka', sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  color: #fff;
  margin: 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid rgba(255, 107, 157, 0.3);
  display: inline-block;
}

.Footer_hoursList__eIoZC {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.Footer_hoursItem__8Kil5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.78rem;
  line-height: 1.35;
}

.Footer_dayName__twXDv {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  min-width: 28px;
}

.Footer_hoursTime__xU6Ct {
  color: #06b6d4;
  font-weight: 500;
  white-space: nowrap;
}

.Footer_hoursLoading__-uuKA,
.Footer_hoursError__XdWE6 {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
}

.Footer_hoursError__XdWE6 {
  color: rgba(255, 107, 157, 0.8);
}

/* Bottom Bar */
.Footer_bottomBar__MTVcu {
  padding: 1rem 0;
  background: rgba(0, 0, 0, 0.2);
}

.Footer_bottomContent__pawrl {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  position: relative;
}

.Footer_copyright__lghYs {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8rem;
  margin: 0;
  text-align: center;
}

.Footer_privacyLink__MXH2T {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.2s ease;
}

.Footer_privacyLink__MXH2T:hover {
  color: #ff6b9d;
}

.Footer_legalLinks__FclgV {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.Footer_legalLinks__FclgV a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 0.8rem;
  transition: color 0.2s ease;
}

.Footer_legalLinks__FclgV a:hover {
  color: #ff6b9d;
}

.Footer_divider__PAION {
  color: rgba(255, 255, 255, 0.3);
}

.Footer_backToTop__BpQVb {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: all 0.3s ease;
}

.Footer_backToTop__BpQVb svg {
  width: 20px;
  height: 20px;
}

.Footer_backToTop__BpQVb:hover {
  background: linear-gradient(135deg, #ff6b9d, #7c3aed);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(255, 107, 157, 0.3);
  border-color: transparent;
}

/* Responsive Styles */
@media (max-width: 1200px) {
  .Footer_footerGrid__xk7f- {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1.5rem;
  }

  .Footer_brandColumn__L2Qv8 {
    grid-column: span 3;
  }

  .Footer_linksColumn__jhB6P,
  .Footer_contactColumn__IyIKK,
  .Footer_hoursColumn__28Xri {
    grid-column: span 1;
  }
}

@media (max-width: 1024px) {
  .Footer_footerGrid__xk7f- {
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
  }

  .Footer_brandColumn__L2Qv8 {
    grid-column: span 2;
  }

  .Footer_contactColumn__IyIKK,
  .Footer_hoursColumn__28Xri {
    grid-column: span 1;
  }
}

@media (max-width: 768px) {
  .Footer_footer__AcWGP {
    margin-top: 2.5rem;
  }

  .Footer_mainFooter__doDxW {
    padding: 2rem 0 1.5rem;
  }

  .Footer_footerGrid__xk7f- {
    grid-template-columns: 1fr 1fr;
    gap: 1.25rem;
  }

  .Footer_brandColumn__L2Qv8 {
    grid-column: span 2;
  }

  .Footer_contactColumn__IyIKK,
  .Footer_hoursColumn__28Xri {
    grid-column: span 1;
  }

  .Footer_logo__Gkrq2 img {
    height: 30px;
  }

  .Footer_socialLinks__O8B6S {
    justify-content: flex-start;
  }

  .Footer_hoursItem__8Kil5 {
    font-size: 0.75rem;
  }

  .Footer_bottomContent__pawrl {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0.75rem;
  }

  .Footer_legalLinks__FclgV {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .Footer_footer__AcWGP {
    margin-top: 2rem;
  }

  .Footer_footer__AcWGP::before,
  .Footer_footer__AcWGP::after {
    display: none;
  }

  .Footer_container__fvqaJ {
    padding: 0 1rem;
  }

  .Footer_mainFooter__doDxW {
    padding: 1.5rem 0 1.25rem;
  }

  .Footer_footerGrid__xk7f- {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }

  .Footer_brandColumn__L2Qv8,
  .Footer_contactColumn__IyIKK,
  .Footer_hoursColumn__28Xri {
    grid-column: span 1;
  }

  .Footer_logo__Gkrq2 img {
    height: 28px;
  }

  .Footer_tagline__1SXmj {
    font-size: 0.8rem;
  }

  .Footer_socialIcon__j0f-t {
    width: 32px;
    height: 32px;
    border-radius: 8px;
  }

  .Footer_socialIcon__j0f-t svg {
    width: 14px;
    height: 14px;
  }

  .Footer_linksColumn__jhB6P h4,
  .Footer_contactColumn__IyIKK h4 {
    font-size: 0.9rem;
  }

  .Footer_linksColumn__jhB6P li a {
    font-size: 0.8rem;
  }

  .Footer_locationCard__2nNih {
    padding: 0.75rem;
    border-radius: 10px;
  }

  .Footer_bottomBar__MTVcu {
    padding: 0.875rem 0;
  }

  .Footer_copyright__lghYs,
  .Footer_legalLinks__FclgV a {
    font-size: 0.75rem;
  }

  .Footer_backToTop__BpQVb {
    width: 32px;
    height: 32px;
    border-radius: 8px;
  }

  .Footer_backToTop__BpQVb svg {
    width: 18px;
    height: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Footer.module.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,6DAA6D;EAC7D,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kFAAkF;EAClF,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,2BAA2B;EAC3B,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,qDAAqD;EACrD,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,2CAA2C;EAC3C,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,2BAA2B;EAC3B,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,kCAAkC;IAClC,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Professional Footer Styles */\n\n.footer {\n  margin-top: 3rem;\n  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);\n  color: #fff;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Decorative gradient orbs */\n.footer::before {\n  content: '';\n  position: absolute;\n  top: -100px;\n  right: -100px;\n  width: 250px;\n  height: 250px;\n  background: radial-gradient(circle, rgba(255, 107, 157, 0.12) 0%, transparent 70%);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.footer::after {\n  content: '';\n  position: absolute;\n  bottom: -80px;\n  left: -80px;\n  width: 200px;\n  height: 200px;\n  background: radial-gradient(circle, rgba(124, 58, 237, 0.1) 0%, transparent 70%);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.container {\n  max-width: var(--max-width);\n  margin: 0 auto;\n  padding: 0 1.5rem;\n  position: relative;\n  z-index: 1;\n}\n\n/* Main Footer */\n.mainFooter {\n  padding: 2.5rem 0 2rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.footerGrid {\n  display: grid;\n  grid-template-columns: 1.4fr 0.9fr 0.9fr 1.2fr 0.8fr;\n  gap: 1.75rem;\n}\n\n/* Brand Column */\n.brandColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.logo {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  text-decoration: none;\n  transition: opacity 0.2s ease;\n}\n\n.logo:hover {\n  opacity: 0.9;\n}\n\n.logo img {\n  height: 36px;\n  width: auto;\n  object-fit: contain;\n}\n\n.tagline {\n  color: rgba(255, 255, 255, 0.65);\n  font-size: 0.85rem;\n  line-height: 1.6;\n  max-width: 260px;\n  margin: 0;\n}\n\n/* Social Links */\n.socialLinks {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 0.25rem;\n}\n\n.socialIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.socialIcon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.socialIcon:hover {\n  background: linear-gradient(135deg, #ff6b9d, #7c3aed);\n  color: #fff;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(255, 107, 157, 0.3);\n  border-color: transparent;\n}\n\n/* Links Columns */\n.linksColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.linksColumn h4,\n.contactColumn h4 {\n  font-family: 'Fredoka', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #fff;\n  margin: 0;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid rgba(255, 107, 157, 0.3);\n  display: inline-block;\n}\n\n.linksColumn ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.linksColumn li a {\n  color: rgba(255, 255, 255, 0.7);\n  text-decoration: none;\n  font-size: 0.85rem;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.linksColumn li a::before {\n  content: '';\n  width: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #ff6b9d, #7c3aed);\n  transition: width 0.3s ease;\n}\n\n.linksColumn li a:hover {\n  color: #fff;\n  transform: translateX(4px);\n}\n\n.linksColumn li a:hover::before {\n  width: 12px;\n}\n\n/* Contact Column */\n.contactColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.locationCard {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 0.875rem;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.locationHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.locationIcon {\n  width: 16px;\n  height: 16px;\n  color: #ff6b9d;\n}\n\n.locationName {\n  font-family: 'Fredoka', sans-serif;\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: #fff;\n}\n\n.address {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.8rem;\n  line-height: 1.45;\n  margin: 0;\n}\n\n.hoursRow {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.8rem;\n}\n\n.clockIcon {\n  width: 14px;\n  height: 14px;\n  color: #7c3aed;\n}\n\n.phoneButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.45rem 0.75rem;\n  background: linear-gradient(135deg, #ff6b9d, #7c3aed);\n  color: #fff;\n  text-decoration: none;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  width: fit-content;\n}\n\n.phoneButton svg {\n  width: 14px;\n  height: 14px;\n}\n\n.phoneButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(255, 107, 157, 0.4);\n}\n\n.directionsLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  color: #06b6d4;\n  text-decoration: none;\n  font-size: 0.8rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.directionsLink svg {\n  width: 14px;\n  height: 14px;\n}\n\n.directionsLink:hover {\n  color: #fff;\n  transform: translateX(3px);\n}\n\n/* Hours Column */\n.hoursColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.hoursColumn h4 {\n  font-family: 'Fredoka', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #fff;\n  margin: 0;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid rgba(255, 107, 157, 0.3);\n  display: inline-block;\n}\n\n.hoursList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.hoursItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 0.78rem;\n  line-height: 1.35;\n}\n\n.dayName {\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 500;\n  min-width: 28px;\n}\n\n.hoursTime {\n  color: #06b6d4;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.hoursLoading,\n.hoursError {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.5);\n  font-style: italic;\n}\n\n.hoursError {\n  color: rgba(255, 107, 157, 0.8);\n}\n\n/* Bottom Bar */\n.bottomBar {\n  padding: 1rem 0;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.bottomContent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  position: relative;\n}\n\n.copyright {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.8rem;\n  margin: 0;\n  text-align: center;\n}\n\n.privacyLink {\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.privacyLink:hover {\n  color: #ff6b9d;\n}\n\n.legalLinks {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n}\n\n.legalLinks a {\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  font-size: 0.8rem;\n  transition: color 0.2s ease;\n}\n\n.legalLinks a:hover {\n  color: #ff6b9d;\n}\n\n.divider {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.backToTop {\n  position: absolute;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  color: rgba(255, 255, 255, 0.8);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.backToTop svg {\n  width: 20px;\n  height: 20px;\n}\n\n.backToTop:hover {\n  background: linear-gradient(135deg, #ff6b9d, #7c3aed);\n  color: #fff;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(255, 107, 157, 0.3);\n  border-color: transparent;\n}\n\n/* Responsive Styles */\n@media (max-width: 1200px) {\n  .footerGrid {\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 1.5rem;\n  }\n\n  .brandColumn {\n    grid-column: span 3;\n  }\n\n  .linksColumn,\n  .contactColumn,\n  .hoursColumn {\n    grid-column: span 1;\n  }\n}\n\n@media (max-width: 1024px) {\n  .footerGrid {\n    grid-template-columns: 1fr 1fr;\n    gap: 1.5rem;\n  }\n\n  .brandColumn {\n    grid-column: span 2;\n  }\n\n  .contactColumn,\n  .hoursColumn {\n    grid-column: span 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer {\n    margin-top: 2.5rem;\n  }\n\n  .mainFooter {\n    padding: 2rem 0 1.5rem;\n  }\n\n  .footerGrid {\n    grid-template-columns: 1fr 1fr;\n    gap: 1.25rem;\n  }\n\n  .brandColumn {\n    grid-column: span 2;\n  }\n\n  .contactColumn,\n  .hoursColumn {\n    grid-column: span 1;\n  }\n\n  .logo img {\n    height: 30px;\n  }\n\n  .socialLinks {\n    justify-content: flex-start;\n  }\n\n  .hoursItem {\n    font-size: 0.75rem;\n  }\n\n  .bottomContent {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 0.75rem;\n  }\n\n  .legalLinks {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer {\n    margin-top: 2rem;\n  }\n\n  .footer::before,\n  .footer::after {\n    display: none;\n  }\n\n  .container {\n    padding: 0 1rem;\n  }\n\n  .mainFooter {\n    padding: 1.5rem 0 1.25rem;\n  }\n\n  .footerGrid {\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n  }\n\n  .brandColumn,\n  .contactColumn,\n  .hoursColumn {\n    grid-column: span 1;\n  }\n\n  .logo img {\n    height: 28px;\n  }\n\n  .tagline {\n    font-size: 0.8rem;\n  }\n\n  .socialIcon {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n  }\n\n  .socialIcon svg {\n    width: 14px;\n    height: 14px;\n  }\n\n  .linksColumn h4,\n  .contactColumn h4 {\n    font-size: 0.9rem;\n  }\n\n  .linksColumn li a {\n    font-size: 0.8rem;\n  }\n\n  .locationCard {\n    padding: 0.75rem;\n    border-radius: 10px;\n  }\n\n  .bottomBar {\n    padding: 0.875rem 0;\n  }\n\n  .copyright,\n  .legalLinks a {\n    font-size: 0.75rem;\n  }\n\n  .backToTop {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n  }\n\n  .backToTop svg {\n    width: 18px;\n    height: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__AcWGP`,
	"container": `Footer_container__fvqaJ`,
	"mainFooter": `Footer_mainFooter__doDxW`,
	"footerGrid": `Footer_footerGrid__xk7f-`,
	"brandColumn": `Footer_brandColumn__L2Qv8`,
	"logo": `Footer_logo__Gkrq2`,
	"tagline": `Footer_tagline__1SXmj`,
	"socialLinks": `Footer_socialLinks__O8B6S`,
	"socialIcon": `Footer_socialIcon__j0f-t`,
	"linksColumn": `Footer_linksColumn__jhB6P`,
	"contactColumn": `Footer_contactColumn__IyIKK`,
	"locationCard": `Footer_locationCard__2nNih`,
	"locationHeader": `Footer_locationHeader__HV2X0`,
	"locationIcon": `Footer_locationIcon__9BLBK`,
	"locationName": `Footer_locationName__RSbjp`,
	"address": `Footer_address__khcda`,
	"hoursRow": `Footer_hoursRow__uwPvH`,
	"clockIcon": `Footer_clockIcon__hX2tC`,
	"phoneButton": `Footer_phoneButton__Grg0s`,
	"directionsLink": `Footer_directionsLink__jnxzK`,
	"hoursColumn": `Footer_hoursColumn__28Xri`,
	"hoursList": `Footer_hoursList__eIoZC`,
	"hoursItem": `Footer_hoursItem__8Kil5`,
	"dayName": `Footer_dayName__twXDv`,
	"hoursTime": `Footer_hoursTime__xU6Ct`,
	"hoursLoading": `Footer_hoursLoading__-uuKA`,
	"hoursError": `Footer_hoursError__XdWE6`,
	"bottomBar": `Footer_bottomBar__MTVcu`,
	"bottomContent": `Footer_bottomContent__pawrl`,
	"copyright": `Footer_copyright__lghYs`,
	"privacyLink": `Footer_privacyLink__MXH2T`,
	"legalLinks": `Footer_legalLinks__FclgV`,
	"divider": `Footer_divider__PAION`,
	"backToTop": `Footer_backToTop__BpQVb`
};
export default ___CSS_LOADER_EXPORT___;
